import React from 'react'
import { ReturnContactInfoProps } from './ReturnContactInfo.types'
import css from './ReturnContactInfo.styles.scss'

const ReturnContactInfo: React.FC<ReturnContactInfoProps> = ({
  reservation,
}) => (
  <div className={css.ReturnContactInfo}>
    <p className={css.ReturnContactInfo__NameInfo}>
      Contact{' '}
      <span className={css.ReturnContactInfo__Name}>{reservation.name}</span>{' '}
      directly for information about how to return or exchange this item.
    </p>
    <div className={css.ReturnContactInfo__Email}>
      <div className={css.ReturnContactInfo__Email__Label}>Email address</div>
      <div className={css.ReturnContactInfo__Email__Address}>
        {reservation.email}
      </div>
    </div>
  </div>
)

export default ReturnContactInfo
